/**
 * Router table for the admin dashboard.
 * Mirrors the web client structure but for the Phase 9 admin surface.
 */

import { createBrowserRouter, Navigate, RouterProvider, Outlet } from 'react-router-dom';

import { AuthProvider } from '@/auth/AuthContext';
import { RequireAuth } from '@/auth/guards';
import { AdminLayout } from '@/app/AdminLayout';
import { AuthLayout } from '@/app/AuthLayout';
import { LoginScreen } from '@/features/auth/LoginScreen';
import { DashboardScreen } from '@/features/dashboard/DashboardScreen';
import { UsersScreen } from '@/features/users/UsersScreen';
import { ReportsScreen } from '@/features/reports/ReportsScreen';
import { SubscriptionsScreen } from '@/features/subscriptions/SubscriptionsScreen';
import { AuditLogsScreen } from '@/features/audit/AuditLogsScreen';
import { SystemScreen } from '@/features/system/SystemScreen';
import { NotFoundScreen } from '@/features/notfound/NotFoundScreen';

import '@/app/global.css';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Navigate to="/login" replace />,
  },
  {
    path: '/login',
    element: (
      <AuthLayout>
        <LoginScreen />
      </AuthLayout>
    ),
  },
  {
    element: (
      <RequireAuth>
        <AdminLayout>
          <Outlet />
        </AdminLayout>
      </RequireAuth>
    ),
    children: [
      { path: '/dashboard', element: <DashboardScreen /> },
      { path: '/users', element: <UsersScreen /> },
      { path: '/reports', element: <ReportsScreen /> },
      { path: '/subscriptions', element: <SubscriptionsScreen /> },
      { path: '/audit-logs', element: <AuditLogsScreen /> },
      { path: '/system', element: <SystemScreen /> },
    ],
  },
  { path: '*', element: <NotFoundScreen /> },
]);

export function AppRouter() {
  return (
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  );
}
